import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ConfigService } from '../../shared/services/config.service';
import {
  DataService,
  DataRequestDto,
  SingleDataRequestDto,
  SingleDataResponseDto,
} from '../../../api-main';
import { Observable } from 'rxjs';
import { UplotResponseData } from '../../shared/components/graph-uplot/graph/models/UplotResponseData.model';
import { LocaleSessionService } from '../../shared/services/localeSession.service';
import { formatUplotDateForRequest } from '../../shared/utils/formatDateForRequest';

@Injectable({
  providedIn: 'root',
})
export class DataServiceProvider {
  private http = inject(HttpClient);
  private dataService = inject(DataService);
  private localeSession = inject(LocaleSessionService);

  constructor() {
    this.dataService = new DataService(this.http, ConfigService.getApiConfig(), undefined);
  }

  getData(request: DataRequestDto): Observable<UplotResponseData> {
    request.min = formatUplotDateForRequest(request.min, this.localeSession);
    request.max = formatUplotDateForRequest(request.max, this.localeSession);

    return (this.dataService.dataControllerList(request) as any) as Observable<UplotResponseData>;
  }

  getSingleData(request: SingleDataRequestDto): Observable<SingleDataResponseDto[]> {
    return this.dataService.dataControllerGetSingleData(request);
  }
}
